import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../services/PostTemplate";
import { useHistory } from "react-router-dom";

const ResetPassword = () => {

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");

    let history = useHistory();

    const handleLogout = () => {
        localStorage.clear();
        window.location.reload();
    };

    const formik = useFormik({
        initialValues: {
            currPass: "",
            newPass: "",
            newPass1: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.currPass) {
                errors.currPass = "Current Password is required.";
            }
            if (!data.newPass) {
                errors.newPass = "New Password is required.";
            } else {
                // Password validation rules
                const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
                if (!passwordRegex.test(data.newPass)) {
                    errors.newPass = "Password should be a minimum of 8 characters, have at least 1 uppercase, be alphanumeric, and have 1 special character.";
                }
            }
            if (!data.newPass1) {
                errors.newPass1 = "Confirm Password is required.";
            }
            if (data.newPass && data.newPass1 && data.newPass !== data.newPass1) {
                errors.newPass1 = "Please enter the same password.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                delete data["newPass1"];
                await handlePostRequest(data, "zbizgateway/nonFin/changePassword/changePassword");
                handleLogout();
                formik.resetForm();
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="Change__Password">
                <div class="container" id="container">
                    <div class="form-container sign-in-container">
                        <form action="#" className="Login__Form" onSubmit={formik.handleSubmit}>
                            <div className="p-mb-4">
                                <h3 className="forgetHeading">CHANGE PASSWORD</h3>
                            </div>

                            <div className="p-mt-4">
                                <div className="p-field p-text-left">
                                    <label htmlFor="currPass" className={classNames({ "p-error": isFormFieldValid("currPass") })}>
                                        Current Password
                                    </label>
                                    <input id="currPass" className={classNames({ "p-invalid": isFormFieldValid("currPass") }, "ChangePassword__Input")} name="currPass" value={formik.values.currPass} placeholder="Enter Current Password" onChange={formik.handleChange} type="password" />
                                    {getFormErrorMessage("currPass")}
                                </div>
                                <div className="p-field p-text-left">
                                    <label htmlFor="newPass" className={classNames({ "p-error": isFormFieldValid("newPass") })}>
                                        New Password
                                    </label>
                                    <input className={classNames({ "p-invalid": isFormFieldValid("newPass") }, "ChangePassword__Input")} name="newPass" placeholder="Enter New Password" value={formik.values.newPass} onChange={formik.handleChange} type="password" />
                                    {getFormErrorMessage("newPass")}
                                </div>

                                <div className="p-field p-text-left">
                                    <label htmlFor="newPass1" className={classNames({ "p-error": isFormFieldValid("newPass1") })}>
                                        Confirm New Password
                                    </label>
                                    <input className={classNames({ "p-invalid": isFormFieldValid("newPass1") }, "ChangePassword__Input")} name="newPass1" placeholder="Enter New Password" value={formik.values.newPass1} onChange={formik.handleChange} type="password" />
                                    {getFormErrorMessage("newPass1")}
                                </div>

                                <div className="Down__Btn p-mt-4">
                                    <Button label="Cancel" className="Btn__Transparent" type="button" onClick={() => {
                                        history.push("/");
                                    }} />
                                    <Button className="Btn__Dark" label="Submit" icon={loadingIcon || ""} iconPos="right" disabled={loading} type="submit" />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
